import React from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import Tab from './Tab';
import { ImUser } from 'react-icons/im';
import { FaCalendarAlt } from 'react-icons/fa';

const Wrapper = styled.div``;

const InnerWrapper = styled.div`
  padding: 0 0 3rem 0;
`;

const StatisticsTab = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #A5CBFF;
  border-radius: .3rem;
  height: 55px;
  margin-bottom: 35px;
  overflow: hidden;
`;

const TabItem = styled.li`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #5F9DF0;
  background-color: #fff;
  cursor: pointer;

  & svg {
    font-size: 1.5rem;
    margin-right: 20px;
    padding-bottom: 3px;
  }

  &.active {
    background-color: #5F9DF0;
    color: #fff;
  }
`;

const Statistics = ({
  activeTab,
  onChangeTab,
  renderingComponent,
}) => {
  return (
    <Wrapper>
      <StatisticsTab>
        <TabItem onClick={() => {if(activeTab !== "member") onChangeTab('member')}} className={activeTab === "member" ? "active" : ""}><FaCalendarAlt />날짜별 회원 조회</TabItem>
        <TabItem onClick={() => {if(activeTab !== "membership") onChangeTab('membership')}} className={activeTab === "membership" ? "active" : ""}><ImUser />회원권별 회원 조회</TabItem>
      </StatisticsTab>
      <InnerWrapper>
        {renderingComponent}
      </InnerWrapper>
    </Wrapper>
  );
};

export default Statistics;
